import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { actions } from '../../store/userMessaging';
import { actions as userActions } from '../../store/user';
import errorContextBuilder from '../../helpers/error/errorContextBuilder';
import normalizeError from '../../helpers/error/normalizeError';

const { clearMessage } = actions;

export default function useUserMessaging(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const hasMessage = useSelector(store => store.userMessaging.hasMessage);
  const messageContainer = useSelector(store => store.userMessaging.message);
  const hasFailedAction = useSelector(
    store => store.userMessaging.hasFailedAction
  );
  const failedAction = useSelector(store => store.userMessaging.failedAction);
  const translateLanguageContent = useSelector(
    store => store.userMessaging.translateLanguageContent
  );

  const { userMessageDomain } = props;

  const [isOpen, setIsOpen] = useState(hasMessage);
  const [message, setMessage] = useState({});
  const [buttons, setButtons] = useState([]);

  const buttonActions = {
    LOGOUT: () => dispatch(userActions.logout()),
    GOTO: to => history.push(to),
    DISMISS: () => handleClose(),
    DISPATCH: action => dispatch(action)
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const createButtons = (availableActions, messageButtons) => {
    return messageButtons.slice().map(button => {
      let buttonAction = Array.isArray(button.action)
        ? button.action
        : [button.action];
      let actionType = buttonAction[0];
      let args = buttonAction.slice(1);
      let action =
        typeof actionType === 'string'
          ? availableActions[actionType]
          : actionType;
      button.title = translateLanguageContent[button.title.toUpperCase()] || button.title;
      button.onClick = () => handleClose(() => action(...args));
      return button;
    });
  };

  useEffect(() => {
    setIsOpen(hasMessage);
    setMessage(messageContainer);
    setButtons(createButtons(buttonActions, messageContainer.buttons));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMessage, messageContainer]);

  useEffect(() => {
    if (hasFailedAction) {
      let context = errorContextBuilder(failedAction, userMessageDomain);
      let message = normalizeError(failedAction.error, context, translateLanguageContent);
      let buttons = createButtons(buttonActions, message.userMessage.buttons);
      setMessage(message.userMessage);
      setButtons(buttons);
      setIsOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [failedAction, hasFailedAction]);

  const handleClose = cb => {
    setIsOpen(false);
    dispatch(clearMessage());
    if (typeof cb === 'function') cb();
  };

  return {
    isOpen,
    handleClose,
    message,
    buttons
  };
}
